import React, { FunctionComponent, useMemo } from 'react';
import styles from './input.module.scss';
import { useGlobalTranslations } from '../../../../hooks/use-global-translations';

export interface IInputProps {
  label: string;
  name: string;
  errorMessage: string;
  required?: boolean;
  value: string;
  type?: string;
  className?: string;
  onChange: (event: React.SyntheticEvent) => void;
}

const InputComponent: FunctionComponent<IInputProps> = ({
  label,
  errorMessage,
  required,
  value,
  type,
  name,
  className,
  onChange
}) => {
  const { optional, emailIsIncorrect } = useGlobalTranslations();
  const displayErrorMessage = useMemo(() => {
    if (type === 'email' && value) {
      return emailIsIncorrect;
    }

    return errorMessage;
  }, [emailIsIncorrect, errorMessage, type, value]);

  return (
    <React.Fragment>
      {type !== 'textarea' ? (
        <label className={`${styles.inputWrapper} ${className && className}`}>
          <input
            className={styles.inputField}
            required={required}
            value={value}
            type={type ? type : 'text'}
            onChange={onChange}
            name={name}
            inputMode={name === 'phoneNumber' ? 'numeric' : undefined}
          />
          <div className={styles.label}>
            {label}
            {!required && (
              <span className={styles.smallText}>({optional})</span>
            )}
          </div>
          <div className={styles.errorMessage}>{displayErrorMessage}</div>
        </label>
      ) : (
        <label className={`${styles.inputWrapper} ${className && className}`}>
          <textarea
            className={`${styles.textarea} ${className && className}`}
            required={required}
            value={value}
            onChange={onChange}
            name={name}
          />
          <div className={styles.label}>
            {label}
            {!required && (
              <span className={styles.smallText}>({optional})</span>
            )}
          </div>
          <div className={styles.errorMessage}>{errorMessage}</div>
        </label>
      )}
    </React.Fragment>
  );
};

export const Input = React.memo(InputComponent);
